module.exports = __webpack_public_path__ + "img/NL.ebcd669e.svg";